export class UserGroupPermission {
  id: number = -1;
  userGroupId: number = -1;
  permissionId: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
